export default __webpack_public_path__ + "static/media/mothy.d789ba35.svg";